<template>
  <div v-if="isStartedParticipant && authorizableDevices.length > 0">
    <div
      class="alert alert-warning"
      role="alert"
    >
      It looks like your {{ authorizableDevices[0].Source.name }} isn't connected. <a href="#" class="alert-link" :data-authorize-url="authorizableDevices[0].urls.oauth_start" :data-logout-url="authorizableDevices[0].urls.logout">Click here</a> to re-authorize your device.
    </div>
  </div>
</template>

<script>
import { mapGetters} from 'vuex';
import {format as f, parseISO} from 'date-fns';

export default {
  name: "DeviceAuth",
  filters: {
    formatDate(date, format) {
      return f(parseISO(date), format);
    }
  },
  computed: {
    ...mapGetters(['isStartedParticipant', 'authorizableDevices']),
  },
}
</script>

<style scoped>

</style>
